import { System } from "../TestData/systems"

export type LAN_Controller = {
  id: number;
  name: string
};

export const LAN_CrontrollerData: LAN_Controller[] = [
  {
    id: 1,
    name: "LAN_Controller1",
  },
  {
    id: 2,
    name: "LAN_Controller2",
  }
]

export type AICO_IO = {
  id: number
  name: string
  type: number
} & Partial<Pick<System, "systemId">>

export const AICO_IO_Data: AICO_IO[] = [
  {
    id: 1,
    name: "AICO_IO1",
    type: 1,
    systemId: 1
  },
  {
    id: 2,
    name: "AICO_IO2",
    type: 1,
    systemId: 1
  },
  {
    id: 3,
    name: "AICO_IO3",
    type: 1,
    systemId: 1
  },
  {
    id: 4,
    name: "AICO_IO4",
    type: 1,
    systemId: 1
  },
  {
    id: 5,
    name: "AICO_IO5",
    type: 1,
    systemId: 1
  },
  {
    id: 6,
    name: "AICO_IO6",
    type: 1,
    systemId: 1
  },
  {
    id: 7,
    name: "AICO_IO7",
    type: 1,
    systemId: 2
  },
  {
    id: 8,
    name: "AICO_IO8",
    type: 1,
    systemId: 2
  },
  {
    id: 9,
    name: "AICO_IO9",
    type: 1,
    systemId: 2
  },
  {
    id: 10,
    name: "AICO_IO10",
    type: 1,
    systemId: 2
  }
  ,
  {
    id: 10,
    name: "AICO_IO11",
    type: 1
  }
  ,
  {
    id: 10,
    name: "AICO_IO12",
    type: 1
  }
]